var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:none;stroke:#fff;opacity:0.2;}.c,.d,.e{fill:#fff;}.c{opacity:0.7;}.e{opacity:0.5;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fc183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0da750"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-597 -6095)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(597 6095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2169,6276v17",
    transform: "translate(-1532 -178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2149.625,6284.459,2136,6289",
    transform: "translate(-1532 -138.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M2169,6313l-15-5v20l15,5Z",
    transform: "translate(-1532 -183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M2184,6308l-15,5v20l15-5Z",
    transform: "translate(-1532 -183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M2169,6303l-15,5,15,5,15-5Z",
    transform: "translate(-1532 -183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2139,6284.459l13.625,4.542",
    transform: "translate(-1482.625 -138.001)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3D);
export default __webpack_public_path__ + "static/media/3d.c7bb468b7783e43068a8edadb161267d.svg";
export { ForwardRef as ReactComponent };